/*
 state.js is a composable function that returns the state for element that must be 
 accessible anywhere in the application.

    add boolean state for testing

*/
export const useTest = () => useState('test', () => false);
